
import {onMounted, ref} from "vue"
export default({
    name:"registerView",
    props:['baseUrl'],
    setup(props:any){
        const isBtnCreateUserLoginShown = ref( false);
        const isBtnCreateUserLoginDisabled = ref(false);
        const userName = ref("");
        const password = ref("");
        const isValidateNotRobotShown = ref(true);
        const registrationStatus = ref(localStorage.getItem("registrationStatus"))

        // var onloadFunction = function(){
        //   console.log("this is a test log 11");
        //   `${document.getElementById('btnCreateUserLogin')}.disabled = true`;
        //   console.log("this is a test log")
        //  }
        //  onloadFunction();

        const reloadPage = () => {
            window.location.reload();
            window.location.reload();
            window.location.reload();
            //document.getElementById('btnCreateUserLogin')?.style.display = '';//disabled = true;

        }

        const showBtnCreateUserLogin = ()=>{
            alert("isBtnCreateUserLoginShown :" + isBtnCreateUserLoginShown.value);
            isBtnCreateUserLoginShown.value = true;
            alert("isBtnCreateUserLoginShown :" + isBtnCreateUserLoginShown.value);
        }
        
        const createUserLogin = ()=>{
            if(userName.value == null || userName.value == "" || userName.value.indexOf("@") < 0)
            {
                
                registrationStatus.value="Please Enter a valid user name. Note that only email is accepted as userName.";
                localStorage.setItem("registrationStatus", registrationStatus.value);
                alert(registrationStatus.value)

                return;
            }

            if(password.value == null || password.value == "")
            {
                registrationStatus.value = "Please Enter a valid password";
                localStorage.setItem("registrationStatus", registrationStatus.value);
                alert(registrationStatus.value)
                return;
            }
            localStorage.setItem("userName", userName.value);
            isBtnCreateUserLoginDisabled.value = true;
            let requestUrl = props.baseUrl + "Login/CreateUserLoginForGuard";
            let requestContent = {
                method:"POST",
                headers:{
                    // "Authorization":`Bearer ${localStorage.getItem("Guardtoken")}`,
                    "Content-Type":"application/json"
                },
                body: JSON.stringify({
                    UserName : userName.value,
                    Password: password.value
                })
            }

            //console.log("requestUrl : ", requestUrl, " requestContent :", requestContent);
            fetch(requestUrl, requestContent)
            .then(response => {
                //console.log("response ",response);
                let res =response.json();
                //console.log("res ",res);
                return res;
            })
            .then(res => 
            {
                if(res.error == "AlreadyExistingUser")
                {
                    registrationStatus.value = "User name '"+ localStorage.getItem('userName') + "' already taken by someone. Please enter some other user-name.";
                    localStorage.setItem("registrationStatus", registrationStatus.value);
                    alert(registrationStatus.value);
                    reloadPage();
                }
                else if(res.usrName != null || res.userName != "")
                {
                    isBtnCreateUserLoginShown.value = false;
                    // console.log("User account has been created successfully.");
                    registrationStatus.value = "User account has been created successfully. A validation link has been sent to your email address. Please click that link to activate your account.";
                    localStorage.setItem("registrationStatus", registrationStatus.value);
                    alert(registrationStatus.value);
                    reloadPage();
                    // `${document.getElementById('btnCreateUserLogin')}.disabled = true`;

                }
            })
            .catch(error => {
                registrationStatus.value = "User account could not be created. Please try again.";
                localStorage.setItem("registrationStatus", registrationStatus.value);
                alert(registrationStatus.value);
                reloadPage();
            });

            
        }

        onMounted( ()=>{
            isBtnCreateUserLoginShown.value = false;//true;//true;//
            isValidateNotRobotShown.value=true;
            // alert("onMounted onMounted onMounted.");
            // var btnCreateUserLogin = window.document.getElementById('btnCreateUserLogin').;
            // btnCreateUserLogin.disabled= true;
            // `${document.getElementById('btnCreateUserLogin')}.disabled = true`;
            // `${document.getElementById('btnCreateUserLogin').disabled}` = true;
        })

        return{
            userName,
            password,
            createUserLogin,
            isBtnCreateUserLoginShown,
            isBtnCreateUserLoginDisabled,
            showBtnCreateUserLogin,
            reloadPage,
            isValidateNotRobotShown,
            registrationStatus,
        }


    }
});
